import React, { PropsWithChildren } from 'react';
import {
  CardFooter as ChakraUICardFooter,
  Stack,
  SystemProps,
  CardFooterProps as ChakraCardFooterProps,
  Flex,
} from '@chakra-ui/react';

interface CardFooterProps extends PropsWithChildren, Omit<ChakraCardFooterProps, 'children'> {
  justifyContent?: SystemProps['justifyContent'];
}

export const CardFooter: React.FC<CardFooterProps> = ({ justifyContent = 'end', children, ...rest }) => {
  /**
   * DOM
   */
  return (
    <ChakraUICardFooter {...rest} data-object-type="core-card-footer" justifyContent={justifyContent}>
      {children}
    </ChakraUICardFooter>
  );
};
